// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ItemCard = registerClientReference(
    function() { throw new Error("Attempted to call ItemCard() from the server but ItemCard is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/components/item-card.tsx <module evaluation>",
    "ItemCard",
);
export const ItemCardSkeleton = registerClientReference(
    function() { throw new Error("Attempted to call ItemCardSkeleton() from the server but ItemCardSkeleton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/components/item-card.tsx <module evaluation>",
    "ItemCardSkeleton",
);
